import { WhoWillReceiveCareStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareStep"
import { WhatKindLowTestosteroneStep } from "#/components/carrot-card-cost-share/steps/views/WhatKindLowTestosteroneStep"
import {
  GeneralSteps,
  LowTestosteroneSteps,
  SectionName
} from "#/components/carrot-card-cost-share/workflows/step-library"
import { PleaseConfirmTwoThingsStep } from "#/components/carrot-card-cost-share/steps/views/PleaseConfirmTwoThingsStep"
import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"

export enum Workflows {
  LOW_TESTOSTERONE = "Low Testosterone"
}

export const lowTestosteroneSteps = [
  { name: LowTestosteroneSteps.WHO_WILL_RECEIVE_CARE_LOW_T, component: WhoWillReceiveCareStep },
  { name: LowTestosteroneSteps.WHAT_KIND_LOW_TESTOSTERONE, component: WhatKindLowTestosteroneStep },
  { name: LowTestosteroneSteps.PLEASE_CONFIRM_TWO_THINGS, component: PleaseConfirmTwoThingsStep },
  { name: LowTestosteroneSteps.EXPENSE_NOT_COVERED_LOW_T, component: ExpenseNotCoveredStep }
]

//prettier-ignore
const lowTestosteroneFlow: LowTestosteroneFlowTransition[] = [
  { at: LowTestosteroneSteps.WHO_WILL_RECEIVE_CARE_LOW_T,  given: "ELIGIBLE",   goto: LowTestosteroneSteps.WHAT_KIND_LOW_TESTOSTERONE },
  { at: LowTestosteroneSteps.WHO_WILL_RECEIVE_CARE_LOW_T,  given: "INELIGIBLE", goto: LowTestosteroneSteps.EXPENSE_NOT_COVERED_LOW_T },
  { at: LowTestosteroneSteps.WHAT_KIND_LOW_TESTOSTERONE,   given: "",           goto: LowTestosteroneSteps.PLEASE_CONFIRM_TWO_THINGS },
  { at: LowTestosteroneSteps.PLEASE_CONFIRM_TWO_THINGS,    given: "",           goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: LowTestosteroneSteps.EXPENSE_NOT_COVERED_LOW_T,    given: "",           end: true }
]

type LowTestosteroneFlowTransition =
  | { at: LowTestosteroneSteps; given: string; goto: LowTestosteroneSteps; sectionName?: undefined }
  | { at: LowTestosteroneSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: LowTestosteroneSteps; given: string; end: true }

export const lowTestosteroneWorkflows = [{ name: Workflows.LOW_TESTOSTERONE, workflow: lowTestosteroneFlow }]
